<script>
import SeatingComponent  from './seating.component.vue';
import AgreementComponent  from './agreementList.component.vue';
export default {
  components: {
    SeatingComponent,
    AgreementComponent
  },
  props: {
    module: Object,
  },
  data: () => ({
    item: Object
  }),
  watch: {},
  methods: {},
  mounted() {
    this.item = this.module.tour;
  },
  computed: {},
};
</script>
<template>
  <div class="p-t-c-i" >
    <div class="p-t-c-i__header">
    <label class="card-title__name">Тур: {{item.name}}</label>
    <button type="button" aria-label="Close" class="el-dialog__headerbtn" @click="$emit('close')">
      <i class="el-dialog__close el-icon el-icon-close"></i>
    </button>
    </div>
    <div class="p-t-c-it-board__body">
      <AgreementComponent :module="module.tour" />
      <SeatingComponent :module="module.tour"/>
    </div>
  </div>
</template>
<style lang="scss">
.p-t-c-it-board__body{
  display: flex;
  .card-agreement{
    width: 50%;
    padding: 20px;
    .card-title__btn {
      height: 0px;
    }
  }
}
</style>
